import { render } from "./ShortTextInputComponent.vue?vue&type=template&id=2f670849"
import script from "./ShortTextInputComponent.vue?vue&type=script&lang=js"
export * from "./ShortTextInputComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__